function removePublicPrefix(key) {
  return key.replace('public/', '');
}

export default removePublicPrefix;
